import { Typography } from "@mui/material";
import { UnitCountRadioGroup } from "./UnitCount/UnitCountRadioGroup";
import { useNavigate } from "react-router";
import { navigateToPolicyStep, NewPolicyRoutes } from "@routing/paths";
import { useAppDispatch } from "@redux/hooks";
import { setUnitCount } from "@covertree/new-business-redux";

export function UnitCountStep() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onUnitCountSelect = (unitCount: unknown) => {
    if (typeof unitCount !== "string") return;
    dispatch(setUnitCount(unitCount));
    navigateToPolicyStep(
      navigate,
      NewPolicyRoutes.HOME_ADDRESS,
      NewPolicyRoutes.UNIT_COUNT
    );
  };

  return (
    <>
      <Typography variant="h4" mb={3}>
        Unit Count
      </Typography>
      <UnitCountRadioGroup onOptionSelect={onUnitCountSelect} />
    </>
  );
}
